import { detectPlatform } from "@/utils/o11y/environment";
import { waitUntil } from "@vercel/functions";

export const fireAndForget = (promise: PromiseLike<unknown>) => {
  const actualPromise = Promise.resolve(promise);
  if (detectPlatform() === "vercel") {
    waitUntil(
      actualPromise.catch((err) => {
        console.error("Fire-and-forget error:", err);
      })
    );
  } else {
    actualPromise.catch((err) => {
      console.error("Fire-and-forget error:", err);
    });
  }
};
